import React, { useEffect, useState } from "react";
import "./returnOrderRequestFilter.scss";
import {
  AppBar,
  Avatar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import orderReturnRequestStore from "../../../stores/orderReturnRequestStore";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker

// Icon
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReturnOrderRequestFilter = ({
  orderID,
  setOrderID,
  customerName,
  setCustomerName,
  staringRequestDate,
  setStaringRequestDate,
  endingRequestDate,
  setEndingRequestDate,
  staringReturnDate,
  setStaringReturnDate,
  endingReturnDate,
  setEndingReturnDate,
  staringPrice,
  setStaringPrice,
  endingPrice,
  setEndingPrice,
  status,
  setStatus,
}) => {
  const max_width600 = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [endingRequestDateError, setEndingRequestDateError] = useState(false);
  const [endingReturnDateError, setEndingReturnDateError] = useState(false);
  const [endingPriceError, setEndingPriceError] = useState(false);
  const todayDate = new Date();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    let flag = true;
    if (
      orderID === "" &&
      customerName === "" &&
      staringRequestDate === null &&
      endingRequestDate === null &&
      staringReturnDate === null &&
      endingReturnDate === null &&
      staringPrice === "" &&
      endingPrice === "" &&
      status === ""
    ) {
      OrderReturnRequestStore.setOrderReturnRequestFilterApply({ value: 0 });
    } else {
      if (staringRequestDate !== null) {
        if (endingRequestDate === null) {
          flag = false;
          setEndingRequestDateError(true);
        } else {
          setEndingRequestDateError(false);
        }
      }
      if (staringReturnDate !== null) {
        if (endingReturnDate === null) {
          flag = false;
          setEndingReturnDateError(true);
        } else {
          setEndingReturnDateError(false);
        }
      }
      if (staringPrice !== "") {
        if (endingPrice === "") {
          flag = false;
          setEndingPriceError(true);
        } else {
          setEndingPriceError(false);
        }
      }

      if (flag) {
        OrderReturnRequestStore.setOrderReturnRequestFilterApply({
          value: ++OrderReturnRequestStore.orderReturnRequestFilterApply,
        });
      }
    }
    if (flag) {
      handleClose();
    }
  };

  const clearAll = () => {
    OrderReturnRequestStore.setOrderReturnRequestFilterApply({ value: 0 });
    setOrderID("");
    setCustomerName("");
    setStaringRequestDate(null);
    setEndingRequestDate(null);
    setStaringReturnDate(null);
    setEndingReturnDate(null);
    setStaringPrice("");
    setEndingPrice("");
    setStatus("");
  };

  return (
    <div className="order-filter">
      <div className="filter-btn">
        <Chip
          avatar={
            <Avatar className="avatar">
              <FilterListRoundedIcon className="icon" />
            </Avatar>
          }
          label={<p>Filter</p>}
          variant="outlined"
          onClick={handleClickOpen}
        />
      </div>
      <Dialog
        fullScreen={max_width600 ? true : false}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
      >
        {max_width600 ? (
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ background: "#000" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseRoundedIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Search Filter
              </Typography>
              <Button autoFocus color="inherit" onClick={handleApply}>
                Apply
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <DialogTitle>Search Filter</DialogTitle>
        )}

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={
                    OrderReturnRequestStore.orderReturnRequestFilterApply === 0
                      ? true
                      : false
                  }
                  onClick={clearAll}
                >
                  Clear All
                </Button>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Order ID"
                variant="outlined"
                fullWidth
                name="orderID"
                value={orderID}
                onChange={(e) => {
                  const { value } = e.target;
                  setOrderID(value);
                }}
                InputProps={{
                  endAdornment: orderID !== "" && (
                    <IconButton size="small" onClick={() => setOrderID("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Customer Name"
                variant="outlined"
                fullWidth
                name="customerName"
                value={customerName}
                onChange={(e) => {
                  const { value } = e.target;
                  setCustomerName(value);
                }}
                InputProps={{
                  endAdornment: customerName !== "" && (
                    <IconButton
                      size="small"
                      onClick={() => setCustomerName("")}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Request Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="staringRequestDate"
                    value={staringRequestDate}
                    onChange={(value) => {
                      setStaringRequestDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringRequestDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringRequestDate(null);
                    setEndingRequestDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Request Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingRequestDate"
                    value={endingRequestDate}
                    onChange={(value) => {
                      setEndingRequestDate(value);
                      setEndingRequestDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingRequestDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingRequestDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingRequestDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Return Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="startingReturnDate"
                    value={staringReturnDate}
                    onChange={(value) => {
                      setStaringReturnDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringReturnDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringReturnDate(null);
                    setEndingReturnDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Return Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingReturnDate"
                    value={endingReturnDate}
                    onChange={(value) => {
                      setEndingReturnDate(value);
                      setEndingReturnDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingReturnDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingReturnDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingReturnDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Starting Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="startingPrice"
                value={staringPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setStaringPrice(value);
                  }
                }}
                InputProps={{
                  endAdornment: staringPrice !== "" && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setStaringPrice("");
                        setEndingPriceError(false);
                      }}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Ending Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="endingPrice"
                value={endingPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setEndingPrice(value);
                    setEndingPriceError(false);
                  }
                }}
                InputProps={{
                  endAdornment: endingPrice !== "" && (
                    <IconButton size="small" onClick={() => setEndingPrice("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
                error={endingPriceError}
                helperText={endingPriceError && "ending price is required"}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="delivery-status">Status</InputLabel>
                <Select
                  labelId="delivery-status"
                  value={status}
                  label="Status"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setStatus("");
                    } else {
                      setStatus(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={status === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  <MenuItem value="Request">Request</MenuItem>
                  <MenuItem value="Returning">Returning</MenuItem>
                  <MenuItem value="Returned">Returned</MenuItem>
                  <MenuItem value="Cancel">Cancel</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        {!max_width600 && (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleApply}>Apply</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default ReturnOrderRequestFilter;
